import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function ScheduleBindingApi(): BringozApi {
  return {
    base: `/scheduleBinding`,
    infiniteScroll: {
      address: `/scheduleBinding`,
      cmd: 'GET'
    },
    actions: {
      getAgentAllocationBindings: {
        address: 'agents/allocation',
        cmd: 'GET',
        updateable: true
      },
      createAllocationBinding: {
        address: 'allocation',
        cmd: 'PUT',
        updateable: false
      },
      deleteResourceAgentAllocation: {
        address: 'allocation/delete',
        cmd: 'POST',
        updateable: true
      },
      bulkCreateAllocationBinding: {
        address: 'allocation/bulkCreate',
        cmd: 'PUT',
        updateable: false
      },
    }
  }
}

angular
  .module('bringoz.admin.resources')
  .factory('scheduleBindingApi', ScheduleBindingApi);
